var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasCategories
    ? _c("project-explorer", {
        attrs: {
          categories: _vm.projectExplorerCategories,
          source: "whyGamefound",
          "default-category-key": _vm.defaultCategoryKey,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }